export default __webpack_public_path__ + "static/media/img-mobile-banner.379aba83.png";